import { api } from './client'

/**
 * Matter service — clean domain API.
 * Same public interface as the old matterService for easy swap.
 */
const matterService = {
  getMatters: async ({ status = 'active', limit = 50, offset = 0 } = {}) => {
    const resp = await api.get('/matters', { status, limit, offset })
    return { matters: resp.data, total: resp.meta.total }
  },

  getMattersEnriched: async ({ activeStatus = 1, limit = 50, offset = 0 } = {}) => {
    const status = activeStatus === 1 ? 'active' : activeStatus === 2 ? 'inactive' : 'all'
    const resp = await api.get('/matters', { status, limit, offset })
    return { matters: resp.data, total: resp.meta.total }
  },

  getRecentMatters: async () => {
    const resp = await api.get('/matters/recent')
    return resp.data
  },

  searchMatters: async (searchTerm) => {
    const resp = await api.get('/matters', { q: searchTerm })
    return { matters: resp.data, total: resp.meta.total }
  },

  getMatter: async (matterId) => {
    const resp = await api.get(`/matters/${matterId}`)
    return resp.data
  },

  getMatterContacts: async (matterId) => {
    const resp = await api.get(`/matters/${matterId}/contacts`)
    return resp.data
  },

  getMatterDocuments: async (matterId) => {
    const resp = await api.get(`/matters/${matterId}/documents`)
    return resp.data
  },

  getMatterBills: async (matterId) => {
    const resp = await api.get(`/matters/${matterId}/bills`)
    return resp.data
  },

  getMatterActivities: async (matterId) => {
    const resp = await api.get(`/matters/${matterId}/activities`)
    return resp.data
  },

  getMatterNotes: async (matterId, matterNumber) => {
    const params = matterNumber ? { matterNumber } : {}
    const resp = await api.get(`/matters/${matterId}/notes`, params)
    return resp.data
  },

  createMatter: async (matterData) => {
    const resp = await api.post('/matters', matterData)
    return resp.data
  },

  updateMatter: async (matterId, matterData) => {
    const resp = await api.put(`/matters/${matterId}`, matterData)
    return resp.data
  },

  archiveMatter: async (matterId) => {
    const resp = await api.put(`/matters/${matterId}`, { isActive: false })
    return resp.data
  },
}

export default matterService
